/**
 * useDevEnabled — ¿debe mostrarse el módulo de desarrollo (Dev Tools)?
 *
 * Antes esto dependía de `import.meta.env.DEV`, que solo es `true` cuando se
 * corre Vite en local (`npm run dev`). En el servidor dev de la EC2 el
 * frontend es un BUILD de producción, así que ese flag siempre es `false` y
 * el módulo nunca aparecía aunque el entorno fuera "dev".
 *
 * La fuente de verdad correcta es el backend: `GET /api/dev/enabled` devuelve
 * `true` cuando `NODE_ENV !== 'production'`. Así el panel aparece en local y
 * en el entorno dev, y queda oculto automáticamente en producción real.
 *
 * Se cachea a nivel de módulo para no consultar en cada render/montaje.
 */
import { useEffect, useState } from 'react'
import { apiCall } from '@/lib/api'

let cached = import.meta.env.DEV ? true : null // null = aún no consultado
let inflight = null

async function resolveDevEnabled() {
  if (cached !== null) return cached
  if (!inflight) {
    inflight = apiCall('/dev/enabled')
      .then((r) => {
        cached = Boolean(r?.enabled)
        return cached
      })
      .catch(() => {
        cached = false
        return false
      })
      .finally(() => {
        inflight = null
      })
  }
  return inflight
}

export function useDevEnabled() {
  const [enabled, setEnabled] = useState(cached === true)

  useEffect(() => {
    let alive = true
    resolveDevEnabled().then((v) => {
      if (alive) setEnabled(v)
    })
    return () => {
      alive = false
    }
  }, [])

  return enabled
}
